export default "__VITE_ASSET__9419da43__"